import CalendarPage from '@/pmd/pages/CalendarV3Page.vue'
import AppointmentList from '@/pmd/pages/AppointmentList.vue'
import EmptyRouterParent from '../../pmd/pages/EmptyRouterParent.vue'
import { RouteConfig } from 'vue-router'
import { calendarRouteNames } from '@/routes/constants/location'
import { requireAuthAndLocation } from '../auth'
import TroubleshootCalendar from '@/pmd/pages/calendars/TroubleshootCalendar.vue'


export const calendarRoutes: RouteConfig[] = [
  {
    path: 'calendars',
    name: calendarRouteNames.default,
    component: EmptyRouterParent,
    beforeEnter: requireAuthAndLocation,
    children: [
      {
        path: 'view',
        name: calendarRouteNames.calendarPageV2,
        component: CalendarPage,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'appointments',
        name: calendarRouteNames.appointmentList,
        component: AppointmentList,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: ':calendarId/troubleshoot',
        name: calendarRouteNames.troubleshootCalendar,
        component: TroubleshootCalendar,
        beforeEnter: requireAuthAndLocation,
        meta: {
          hideSideBar: true,
          hideTopBar: true,
        },
      },
    ],
  },
]
